import React, { useEffect, useRef, useState } from "react";
import styles from "./Input-style.module.css";
import Tooltip from "../btooltip/Tooltip";
import view from'./view.png'
import hidden from'./hidden.png'
import { decodeHtmlEntities } from "../../utilities/DecodeEntity";
function Input({
  id = null,
  type = null,
  value = null,
  label = null,
  onChange = null,
  name = null,
  maxLength = null,
  errorMsg = null,
  isValid = null,
  elmentconfig = null,
  labelPosition = null,
  onClick = null,
  fieldvalidation = null,
  disabled = false,
  content = null,
  className = null,
  checked = null,
  key = null,
  option = null,
  width,
}) {

  const [isIconFlagePassword, setIsIconFlagePassword] = useState(false)

  const wrapperRef = useRef(null);

  const handleBlur = (e) => {
    setTimeout(() => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(document.activeElement)
      ) {
        setIsIconFlagePassword(false);
      }
    }, 0);
  };

useEffect(() => {
  if (!isIconFlagePassword) return;

  const timeoutId = setTimeout(() => {
    setIsIconFlagePassword(false);
  }, 10000); // 10 seconds

  return () => clearTimeout(timeoutId);
}, [isIconFlagePassword]);

  switch (type) {
    case "text":
      return (
        <>
          <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 ${width != undefined ? "px-5" :" px-8"} `} style={{width:`${width}`}}>
            <div className={styles.form__group}>
              <input
                name={name}
                onChange={onChange}
                value={value}
                type={type}
                id={id}
                className={`${styles.form__field} ${!isValid ? styles.error_field : ""
                  }`}
                placeholder={label}
                maxLength={maxLength}
                aria-label={name}
                fieldvalidation={fieldvalidation}
                disabled={disabled}
              />
              <label
                htmlFor={id}
                className={`${styles.input_label} ${styles.form__label}`}
              >
                {label}
              </label>
              <span
                className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
              >
                {errorMsg}
              </span>
            </div>
          </div>
        </>
      );
    case "text_tooltip":
      return (
        <>
          <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}>
            <div className={styles.form__group}>
              <Tooltip content={content}>
                <input
                  name={name}
                  onChange={onChange}
                  value={value}
                  type={"text"}
                  id={id}
                  className={`${styles.form__field} ${!isValid ? styles.error_field : ""
                    }`}
                  placeholder={label}
                  maxLength={maxLength}
                  aria-label={name}
                  fieldvalidation={fieldvalidation}
                  disabled={disabled}
                />
                <label
                  htmlFor={id}
                  className={`${styles.input_label} ${styles.form__label}`}
                >
                  {label}
                </label>
                <span
                  className={`${!isValid ? styles.errorMsg : styles.errorMsgnot
                    }`}
                >
                  {errorMsg}
                </span>
              </Tooltip>
            </div>
          </div>
        </>
      );
    case "email":
      return (
        <>
          <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}>
            <div className={styles.form__group}>
              <input
                name={name}
                onChange={onChange}
                value={value}
                type={type}
                id={id}
                className={`${styles.form__field} ${!isValid ? styles.error_field : ""
                  }`}
                placeholder={label}
                aria-label={name}
                fieldvalidation={fieldvalidation}
              />
              <label
                htmlFor={id}
                className={`${styles.input_label} ${styles.form__label}`}
              >
                {label}
              </label>
              <span
                className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
              >
                {errorMsg}
              </span>
            </div>
          </div>
        </>
      );
    case "number":
      return (
        <>
          <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}>
            <div className={styles.form__group}>
              <input
                onChange={onChange}
                value={value}
                type={type}
                id={id}
                className={`${styles.form__field} ${!isValid ? styles.error_field : ""
                  }`}
                placeholder={label}
                name={name}
                aria-label={name}
                fieldvalidation={fieldvalidation}
              />
              <label
                htmlFor={id}
                className={`${styles.input_label} ${styles.form__label}`}
              >
                {label}
              </label>
              <span
                className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
              >
                {errorMsg}
              </span>
            </div>
          </div>
        </>
      );
    case "selectIndex":
      return (
        <>
          <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}>
            <div className={styles.form__group}>
              <select
                className={`${styles.form__field} ${styles.form__select} ${!isValid ? styles.error_field : ""
                  }`}
                onChange={onChange}
                defaultValue={value || ""}
                value={value}
                type={type}
                id={id}
                name={name}
                aria-label={name}
                fieldvalidation={fieldvalidation}
              >
                <option value="" selected disabled hidden></option>
                {elmentconfig &&
                  elmentconfig.map((x) => {
                    return (
                      <option key={x.key} value={x.key}>
                        {x.value}
                      </option>
                    );
                  })}
              </select>
              <label
                htmlFor={id}
                className={`${styles.input_label} ${styles.form__label} ${!!value
                  ? styles.select_label_active
                  : styles.select_label_inactive
                  }`}
              >
                {label}
              </label>
              <span
                className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
              >
                {errorMsg}
              </span>
            </div>
          </div>
        </>
      );
    case "select":
      return (
        <>
          <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}>
            <div className={styles.form__group}>
              <select
                className={`${styles.form__field} ${styles.form__select} ${!isValid ? styles.error_field : ""
                  }`}
                onChange={onChange}
                defaultValue={value || ""}
                value={value}
                type={type}
                id={id}
                name={name}
                aria-label={name}
                fieldvalidation={fieldvalidation}
              >
                <option value="" selected disabled hidden></option>
                {elmentconfig &&
                  elmentconfig.map((x) => {
                    return (
                      <option key={x.key} value={x.key}>
                        {x.value}
                      </option>
                    );
                  })}
              </select>
              <label
                htmlFor={id}
                className={`${styles.input_label} ${styles.form__label} ${!!value
                  ? styles.select_label_active
                  : styles.select_label_inactive
                  }`}
              >
                {label}
              </label>
              <span
                className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
              >
                {errorMsg}
              </span>
            </div>
          </div>
        </>
      );
    case "select_contact":
      return (
        <>
          {/* <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}> */}
          <div>
            <div className={styles.form__group}>
              <select
                className={`${styles.form__field} ${styles.form__select} ${!isValid ? styles.error_field : ""
                  }`}
                onChange={onChange}
                defaultValue={value || ""}
                value={value}
                type="select"
                id={id}
                name={name}
                aria-label={name}
                fieldvalidation={fieldvalidation}
              >
                <option value="" selected disabled hidden></option>
                {elmentconfig &&
                  elmentconfig.map((x) => {
                    return (
                      <option key={x.key} value={x.key}>
                        {x.value}
                      </option>
                    );
                  })}
              </select>
              <label
                htmlFor={id}
                className={`${styles.input_label} ${styles.form__label} ${!!value
                  ? styles.select_label_active
                  : styles.select_label_inactive
                  }`}
              >
                {label}
              </label>
              <span
                className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
              >
                {errorMsg}
              </span>
            </div>
          </div>
        </>
      );
    case "select_NFRD":
      return (
        <>
          <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}>
            <div className={styles.form__group}>
              <select
                className={`${styles.form__fieldNFRD} ${!isValid ? styles.error_field : ""
                  }`}
                onChange={onChange}
                defaultValue={value || ""}
                value={value}
                type={"select"}
                id={id}
                name={name}
                aria-label={name}
                fieldvalidation={fieldvalidation}
              >
                <option
                  className={styles.option_color}
                  value=""
                  selected
                  disabled
                  hidden
                ></option>
                {elmentconfig &&
                  elmentconfig.map((x) => {
                    return (
                      <option
                        className={styles.option_color}
                        key={x.key}
                        value={x.key}
                      >
                        {x.value}
                      </option>
                    );
                  })}
              </select>
              <label
                htmlFor={id}
                className={`${styles.input_labelNFRD} ${styles.form__labelNFRD
                  } ${!!value
                    ? styles.select_label_activeNFRD
                    : styles.select_label_inactiveNFRD
                  }`}
              >
                {label}
              </label>
              <span
                className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
              >
                {errorMsg}
              </span>
            </div>
          </div>
        </>
      );
    case "switch":
      return (
        <>
          {labelPosition == "left" ? (
            <div className="mt-2 d-flex justify-content-center">
              <div className="form-check form-switch d-flex justify-content-center">
                <label
                  className="form-check-label fw-bolder text-center"
                  style={{ width: "80%", marginLeft: "16px" }}
                  htmlFor={id}
                >
                  {label}
                </label>
                <input
                  onClick={onClick}
                  style={{ marginLeft: "16px" }}
                  className={`form-check-input ${value ? "switch_input_yes" : "switch_input_no"
                    }`}
                  checked={value}
                  type={"checkbox"}
                  id={id}
                  name={name}
                  aria-label={name}
                  fieldvalidation={fieldvalidation}
                />
              </div>
            </div>
          ) : (
            <div className="mt-2 d-flex justify-content-center">
              <div className="form-check form-switch d-flex justify-content-center">
                <input
                  onClick={onClick}
                  style={{ marginLeft: "16px" }}
                  className={`form-check-input ${value ? "switch_input_yes" : "switch_input_no"
                    }`}
                  type={"checkbox"}
                  id={id}
                  checked={value}
                  name={name}
                  aria-label={name}
                  fieldvalidation={fieldvalidation}
                />
                <label
                  className="form-check-label fw-bolder"
                  style={{ width: "70%", marginLeft: "16px" }}
                  htmlFor={id}
                >
                  {label}
                </label>
              </div>
            </div>
          )}
        </>
      );
    case "password":
      return (
        <>
          <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}>
            <div className={styles.form__group}
             ref={wrapperRef}
             tabIndex={-1}
             onBlurCapture={handleBlur}
            >
              <input
                onChange={onChange}
                value={value}
                 type={ isIconFlagePassword ? 'text' : type}
                 onBlur={() =>handleBlur}
                id={id}
                className={`${styles.form__field} ${!isValid ? styles.error_field : ""
                  }`}
                placeholder={label}
                name={name}
                aria-label={name}
                fieldvalidation={fieldvalidation}
              />
              <label
                htmlFor={id}
                className={`${styles.input_label} ${styles.form__label}`}
              >
                {label}
              </label>
              <span
                className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
              >
                {errorMsg}
              </span>
                <button
                type="button"     
                className={`${styles.maskIconPass}`}
                onClick={() => setIsIconFlagePassword( !isIconFlagePassword)}
                >
                {isIconFlagePassword ? (
                  <img style={{width:"20px"}} id={"eyeIconId"} src={view} alt="view" />
                ) : (
                  <img style={{width:"20px"}} id={"eyeIconId"} src={hidden} alt="hidden" />
                )}
              </button>
            </div>
          </div>
        </>
      );
    case "date":
      return (
        <>
          <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}>
            <div className={styles.form__group}>
              <input
                onChange={onChange}
                value={value}
                type={type}
                id={id}
                className={`${styles.form__field} ${!isValid ? styles.error_field : ""
                  }`}
                placeholder={label}
                name={name}
                aria-label={name}
                fieldvalidation={fieldvalidation}
                max={new Date().toISOString().split("T")[0]}
              // min={new Date(new Date().setFullYear(new Date().getFullYear()-2)).toISOString().split("T")[0]}
              />
              <label
                htmlFor={id}
                className={`${styles.input_label} ${styles.form__label}`}
              >
                {label}
              </label>
              <span
                className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
              >
                {errorMsg}
              </span>
            </div>
          </div>
        </>
      );
    case "filterDate":
      return (
        <>
          <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}>
            <div className={styles.form__group}>
              <input
                onChange={onChange}
                value={value}
                type={"date"}
                id={id}
                className={`${styles.form__field} ${!isValid ? styles.error_field : ""
                  }`}
                placeholder={label}
                name={name}
                aria-label={name}
                fieldvalidation={fieldvalidation}
                max={new Date().toISOString().split("T")[0]}
                min={new Date(new Date().setFullYear(new Date().getFullYear() - 2)).toISOString().split("T")[0]}
              />
              <label
                htmlFor={id}
                className={`${styles.input_label} ${styles.form__label}`}
              >
                {label}
              </label>
              <span
                className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
              >
                {errorMsg}
              </span>
            </div>
          </div>
        </>
      );
    case "checkbox":
      return (
        <>
          <div className="form-check mt-5">
            <input
              style={{ border: "1px solid #152C8C" }}
              onChange={onChange}
              value={value}
              type={"checkbox"}
              id={id}
              className="form-check-input"
              placeholder={label}
              name={name}
              aria-label={name}
              fieldvalidation={fieldvalidation}
              onClick={onClick}
            />
            <label htmlFor={id} className="form-check-label fw-bold">
              {label}
            </label>
          </div>
        </>
      );
    case "checkboxNFRD":
      return (
        <>
          <div className={`${styles.checkBox_NFRD} form-check mt-5`}>
            <input
              style={{ border: "1px solid #152C8C" }}
              onChange={onChange}
              value={value}
              type={"checkbox"}
              id={id}
              className="form-check-input"
              placeholder={label}
              name={name}
              aria-label={name}
              fieldvalidation={fieldvalidation}
              onClick={onClick}
              checked={checked}
              key={key}
            />
            <label
              htmlFor={id}
              className={`form-check-label fw-bold ${className}`}
            >
              {label}
            </label>
          </div>
        </>
      );
    case "checkboxFS":
      return (
        <>
          <div className={`d-flex align-items-center form-check mt-1 ${className}`}>
            <input
              style={{ border: "1px solid #152C8C" }}
              onChange={onChange}
              value={value}
              type={"checkbox"}
              id={id}
              className="form-check-input"
              placeholder={label}
              name={name}
              aria-label={name}
              fieldvalidation={fieldvalidation}
              onClick={onClick}
              checked={checked}
              key={key}
            />
            <label
              htmlFor={id}
              className={`form-check-label fs-base`}
            >
              {decodeHtmlEntities(label)}
            </label>
          </div>
        </>
      );
    case "switch1":
      return (
        <>
          {labelPosition == "left" ? (
            <div className="form-check form-switch row mt-3 text-start">
              <label className="form-check-label col-6" htmlFor={id}>
                {label}
              </label>
              <input
                onClick={onClick}
                style={{ marginLeft: "16px" }}
                className={`form-check-input col-4 ${value ? "switch_input_yes" : "switch_input_no"
                  }`}
                checked={value}
                type={"checkbox"}
                id={id}
                name={name}
                aria-label={name}
                fieldvalidation={fieldvalidation}
              />
            </div>
          ) : (
            <div className="form-check form-switch row mt-3 text-start">
              <input
                onClick={onClick}
                className={`form-check-input col-4 ${value ? "switch_input_yes" : "switch_input_no"
                  }`}
                checked={value}
                type={"checkbox"}
                id={id}
                name={name}
                aria-label={name}
                fieldvalidation={fieldvalidation}
              />
              <label
                className="form-check-label fw-bolder col-6"
                style={{ marginLeft: "16px" }}
                htmlFor={id}
              >
                {label}
              </label>
            </div>
          )}
        </>
      );
    case "switch2":
      return (
        <>
          <div className="form-check form-switch col-6 row mt-3 text-start">
            <label className="form-check-label col-10" htmlFor={id}>
              {label}
            </label>
            <input
              onClick={onClick}
              className={`form-check-input col-2 ${value ? "switch_input_yes" : "switch_input_no"
                }`}
              checked={value}
              type={"checkbox"}
              id={id}
              name={name}
              aria-label={name}
              fieldvalidation={fieldvalidation}
            />
          </div>
        </>
      );
    case "radio":
      return (
        <>
          <div className={`form-check ${checked ? styles.active_radio : styles.radio_container} mt-3`} onClick={onClick} >
            <input
              className="form-check-input"
              // onClick={onClick}
              checked={checked}
              value={value}
              type={"radio"}
              id={id}
              name={name}
              aria-label={name}
            />
            <label className="form-check-label" htmlFor={id}>
              {label}
            </label>
          </div>
        </>
      );
    case "search":
      return (
        <>
          <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 `}>
            <input
              name={name}
              onChange={onChange}
              value={value}
              type={type}
              id={id}
              className='form-control'
              placeholder={label}
              maxLength={maxLength}
              aria-label={name}
              fieldvalidation={fieldvalidation}
              disabled={disabled}
              style={{ backgroundColor: "#fff" }}
            />
          </div>
        </>
      )
    default:
      break;
  }

  return <React.Fragment></React.Fragment>;
}

export default Input;
